import { ApprovalMaterializedApprovalFragment } from 'generated/resources/graphql'

import type { RequestComponentProps } from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/base'
import { trackSubmitSwapRequestApproval } from 'modules/shift_management/lib/trackEvents'

import BasePendingApproval from '../BasePendingApprovals'
import { findValueInBlock } from '../FindInEmailBlock'
import RightBlock from './components/RightBlock'
import { CollapseContentData, EmailBlockData } from './types'

const SwapShiftRequests = ({ request, index, removeRequestById }: RequestComponentProps) => {
  /*
   * Object with the data of the email blocks
   */
  const getEmailBlockResources = (flow: ApprovalMaterializedApprovalFragment): EmailBlockData => {
    return {
      id: findValueInBlock(flow, 'swap-shift-id'),
      status: findValueInBlock(flow, 'swap-shift-status'),
      reason: findValueInBlock(flow, 'swap-shift-reason'),
      currentShiftRange: findValueInBlock(flow, 'current-shift-range'),
      currentShiftTimeRange: findValueInBlock(flow, 'current-shift-time-range'),
      requestedShiftRange: findValueInBlock(flow, 'requested-shift-range'),
      requestedShiftTimeRange: findValueInBlock(flow, 'requested-shift-time-range'),
      currentShiftId: findValueInBlock(flow, 'current-shift-id'),
      requestedShiftId: findValueInBlock(flow, 'requested-shift-id'),
      currentShiftAccessId: findValueInBlock(flow, 'current-shift-access-id'),
      requestedShiftAccessId: findValueInBlock(flow, 'requested-shift-access-id'),
      currentShiftColor: findValueInBlock(flow, 'current-shift-color'),
      requestedShiftColor: findValueInBlock(flow, 'requested-shift-color'),
      currentShiftDefaultShiftTitle: findValueInBlock(flow, 'current-shift-default-shift-title'),
      requestedShiftDefaultShiftTitle: findValueInBlock(
        flow,
        'requested-shift-default-shift-title'
      ),
      currentShiftWorkAreaName: findValueInBlock(flow, 'current-shift-work-area-name'),
      requestedShiftWorkAreaName: findValueInBlock(flow, 'requested-shift-work-area-name'),
      currentShiftLocationName: findValueInBlock(flow, 'current-shift-location-name'),
      requestedShiftLocationName: findValueInBlock(flow, 'requested-shift-location-name'),
      currentShiftAddressLine1: findValueInBlock(flow, 'current-shift-address-line-1'),
      requestedShiftAddressLine1: findValueInBlock(flow, 'requested-shift-address-line-1'),
      currentShiftCity: findValueInBlock(flow, 'current-shift-city'),
      requestedShiftCity: findValueInBlock(flow, 'requested-shift-city'),
      currentShiftNotes: findValueInBlock(flow, 'current-shift-notes'),
      requestedShiftNotes: findValueInBlock(flow, 'requested-shift-notes'),
    }
  }

  /**
   * Fetch all the necessary resources and return them
   *
   */

  const fetchResources = async (flow: ApprovalMaterializedApprovalFragment) => {
    const blockData = getEmailBlockResources(flow)

    const hideBasicInformation = true
    return { hideBasicInformation, ...blockData }
  }

  const onSuccess = (action: string, reason?: string) => {
    if (action == 'bulk_approve') trackSubmitSwapRequestApproval(true)
    if (action == 'bulk_reject') trackSubmitSwapRequestApproval(false, reason)
  }

  return (
    <BasePendingApproval
      request={request}
      index={index}
      compact={false}
      getApprovalData={(flow, policy) => fetchResources(flow)}
      removeRequestById={removeRequestById}
      onSuccess={onSuccess}
      collapseContentBlocks={(data) => ({
        // eslint-disable-next-line no-type-assertion/no-type-assertion
        rightBlock: <RightBlock collapseContentData={data as CollapseContentData} />,
      })}
    />
  )
}

export default SwapShiftRequests
